import React from "react";
import { Box, Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolioNew/portfolioSlice";

import useColourPalette from "components/visuals/useColourPalette";
import KPIComparison from "components/visuals/KPIComparison";

import numberFormatter from "utils/numberFormatter";
import { selectIsLoading, selectHasErrors, selectNumberOfStores } from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";
import mathUtils from "utils/mathUtils";

const NumberOfStores = () => {
    const colourPalette = useColourPalette();
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const storeCounts = useAppSelector(selectNumberOfStores);
    const selectedStoreNumberOfStores = storeCounts.selectedStore.totalStoreCount;
    const comparatorNumberOfStores = storeCounts.comparator.totalStoreCount;
    const difference = mathUtils.safePercentageChange(selectedStoreNumberOfStores, comparatorNumberOfStores);
    const differencePositiveSign = difference > 0 ? "+" : "";

    const label = `Number of stores within your ${selectedStore?.name} store's retail zone`;

    return (
        <Box width="100%" height="100%" data-cy="number-of-stores-in-retail-zone">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {selectedStoreNumberOfStores}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {comparatorNumberOfStores}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${selectedComparator?.name} `}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{numberFormatter.toPercentage(difference, true, 2)}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default NumberOfStores;
